import React, { useEffect } from "react";

/** Standalone pages outside Layouts; body is overflow:hidden — this is the scrollport. */
export default function AccountPageScroll({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  useEffect(() => {
    const dental = document.getElementById("dental");
    const prevBody = document.body.style.overflow;
    const prevHtml = document.documentElement.style.overflow;
    const prevDental = dental?.style.overflow ?? "";

    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
    if (dental) dental.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = prevBody;
      document.documentElement.style.overflow = prevHtml;
      if (dental) dental.style.overflow = prevDental;
    };
  }, []);

  return (
    <div
      className={`account-page-scroll fixed inset-0 z-0 overflow-y-auto overflow-x-hidden overscroll-y-contain ${
        className ?? "bg-[#f8f9fb] dark:bg-slate-950"
      }`}
      style={{ WebkitOverflowScrolling: "touch" }}
    >
      {children}
    </div>
  );
}
